<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="$t('tab.inspectionQuery')" style="margin-top: -14px">
        <InspectQuery ref="inspectQuery" :order-status-data="orderStatusData" :storer-data="storerData" @rowDblClick="rowDblClick"></InspectQuery>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.inspection')" forceRender style="margin-top: -14px">
        <InspectEdit ref="inspectEdit" :order-status-data="orderStatusData" @saveDisabled="saveDisabledChange" @saveFinish="saveFinish" @saveStart="saveStart"></InspectEdit>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button type="primary" @click="reset" :disabled="resetDisabled">{{ $t('button.reset') }}</a-button>
        <a-button type="primary" @click="save" :loading="saveLoading" :disabled="saveDisabled">{{ $t('button.save') }}</a-button>
        <a-button type="primary" @click="shelfPrint" :disabled="printDisabled">{{ $t('button.printShelfLabel') }}</a-button>
        <a-button type="primary" @click="rejectPrint" :disabled="printDisabled">{{ $t('button.printRejectLabel') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
  import InspectQuery from '@/views/inbound/inspect/InspectQuery.vue'
  import InspectEdit from '@/views/inbound/inspect/InspectEdit.vue'
  import { findAll, findEnum } from '@/api/Api'

  export default {
    name: 'Inspect',
    components: {
      InspectEdit,
      InspectQuery
    },
    props: {
      'queryParam': {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        activeKey: '1',
        resetDisabled: false,
        saveDisabled: true,
        printDisabled: true,
        saveLoading: false,
        storerData: [],
        orderStatusData: []
      }
    },
    watch: {
      activeKey(key) {
        switch (key) {
          case '1':
            this.resetDisabled = false
            this.saveDisabled = true
            this.printDisabled = true
            break
          case '2':
            this.resetDisabled = false
            this.saveDisabled = false
            this.printDisabled = false
            break
        }
      }
    },
    mounted() {
      findAll('storerFactory', { available: true }).then(res => {
        if (res.success) {
          this.storerData = res.result
        }
      })
      findEnum('OrderStatus').then(res => {
        if (res.success) {
          this.orderStatusData = res.result
        }
      })
    },
    methods: {
      reset() {
        if (this.activeKey === '1') {
          this.$refs.inspectQuery.reset()
        } else {
          let that = this
          this.$confirm({
            title: '是否确认重置?',
            content: '将清空界面收货信息',
            onOk() {
              that.$refs.inspectEdit.clear()
            },
            onCancel() {
            },
            centered: true
          })
        }
      },
      rowDblClick(detail) {
        this.activeKey = '2'
        this.$refs.inspectEdit.clearDetail()
        this.$refs.inspectEdit.pickUpByReceiptDetail(detail)
      },
      saveDisabledChange(saveDisabled) {
        this.saveDisabled = saveDisabled
      },
      save() {
        this.$refs.inspectEdit.saveReceipt()
      },
      saveStart() {
        this.saveLoading = true
      },
      saveFinish() {
        this.saveLoading = false
      },
      shelfPrint() {

      },
      rejectPrint() {

      }
    }
  }
</script>

<style scoped>

</style>